angular.module('tgaAdmin')
  .controller('PaymentModalController', [
    '$scope', '$state', '$window', '$uibModalInstance', '$uibModalStack', 'accountService',
    'modalService', 'stripe', 'extras',
    function (
      $scope, $state, $window, $uibModalInstance, $uibModalStack,
      accountService, modalService, stripe, extras,
    ) {
      $scope.data = {
        alerts: [],
        total: extras.total,
        showCC: extras.promo.type !== 3 && extras.promo.type !== 4 && extras.promo.type !== 5 && extras.total > 0,
        closeButton: extras.closeButton,
      };

      $scope.card = {
        number: null,
        expiry: null,
        cvc: null,
      };

      $scope.viewmodel = {
        ...extras,
        accepted_eula: null,
        code: extras.promo.code,
      };

      $scope.promo = {
        code: extras.promo.code,
        description: extras.promo.description,
        discount: extras.promo.discount,
        final_price: extras.promo.final_price,
        type: extras.promo.type,
      };

      $scope.actions = {
        paymentForm() {
          if ($scope.paymentForm.$invalid) {
            return;
          }

          $scope.loading = true;

          // Prevent closing modal
          $uibModalStack.getTop().value.backdrop = 'static';
          $uibModalStack.getTop().value.keyboard = false;
          $scope.data.closeButton = false;

          if ($scope.data.showCC) {
            const card = {
              number: $scope.card.number,
              exp_month: $scope.card.expiry.month,
              exp_year: $scope.card.expiry.year,
              cvc: $scope.card.cvc,
            };

            stripe.card.createToken(card).then((response) => {
              accountService.submitOrder({
                token: response.id,
                ...$scope.viewmodel,
              }).then(
                () => {
                  $scope.loading = false;
                  $uibModalInstance.close('success');
                }, (err) => {
                  $scope.loading = false;
                  $scope.data.closeButton = true;
                  $scope.actions.createAlert(err.message, 'danger');
                },
              );
            }).catch((err) => {
              $scope.loading = false;
              $scope.data.closeButton = true;
              $scope.actions.createAlert(err.message, 'danger');
            });
          } else {
            accountService.submitOrder($scope.viewmodel).then(
              () => {
                $scope.loading = false;
                $uibModalInstance.close('success');
              }, (err) => {
                $scope.loading = false;
                $scope.data.closeButton = true;
                $scope.actions.createAlert(err.message, 'danger');
              },
            );
          }
        },
        close() {
          $uibModalInstance.dismiss('cancel');
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
      };
    },
  ]);
